import produce from 'immer';
import _ from 'lodash';

import {
  ORDER_ASCENDING,
  ORDER_DESCENDING
} from '../../../utils/constants/tableConstants';
import moshiConfig from '../../../utils/moshiConfig';
import {
  setFilterToStoreDraft,
  setFiltersToStoreDraft
} from '../../../utils/redux/listUtils';

import {
  CLEAR_ADVANCE_DETAIL,
  CLEAR_ADVANCE_LIST_FILTER,
  CLEAR_ADVANCE_PAYMENTS_LIST,
  GET_ADVANCE_DETAIL_FAILURE,
  GET_ADVANCE_DETAIL_IN_PROGRESS,
  GET_ADVANCE_DETAIL_SUCCESS,
  GET_ADVANCE_LIST_FAILURE,
  GET_ADVANCE_LIST_IN_PROGRESS,
  GET_ADVANCE_LIST_SUCCESS,
  GET_PATIENT_ADVANCE_LIST_IN_PROGRESS,
  GET_PATIENT_ADVANCE_LIST_SUCCESS,
  GET_PATIENT_ADVANCE_LIST_FAILURE,
  GET_ADVANCE_PAYMENTS_LIST_FAILURE,
  GET_ADVANCE_PAYMENTS_LIST_IN_PROGRESS,
  GET_ADVANCE_PAYMENTS_LIST_SUCCESS,
  SET_ADVANCE_LIST_FILTER,
  SET_ADVANCE_LIST_FILTERS,
  SET_ADVANCE_LIST_ORDER,
  SET_ADVANCE_LIST_PAGINATION,
  UPDATE_ADVANCE_SUCCESS,
  PATCH_ADVANCE_SUCCESS,
  REMOVE_ADVANCE_SUCCESS,
  CLEAR_PATIENT_ADVANCE_LIST,
  SET_ADVANCE_LIST_INCLUDE_PARAM,
  CLEAR_ADVANCE_LIST_FILTER_NO_POLL
} from './advanceTypes';

import { LOGOUT } from '../../auth/authReducer';

import AdvanceModel from '../../../metadata/model/billing/bill/AdvanceModel';

export const initialState = {
  list: [],
  loadingList: false,
  detail: null,
  loadingDetail: false,
  filter: {
    sortBy: 'issuedAt',
    order: ORDER_DESCENDING
  },
  include: '',
  patientAdvances: {
    list: [],
    loadingList: false
  },
  pagination: {
    resultCount: 0,
    pageCount: 0,
    limit: _.get(moshiConfig, 'list.pagination.limit', 20),
    page: 1
  },
  payments: {
    loadingPaymentsList: false,
    list: []
  }
};

// eslint-disable-next-line default-param-last
const advanceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, ...payload } = action;

    switch (type) {
      case GET_ADVANCE_LIST_IN_PROGRESS:
        draft.loadingList = true;
        break;
      case GET_ADVANCE_LIST_SUCCESS:
        const responsePayload = _.get(payload, 'response', payload);
        const billingAdvances = _.get(responsePayload, 'data', []);

        const maxResultsRaw = _.get(
          responsePayload,
          'headers.x-total-count',
          draft.pagination.limit
        );
        const maxResults = _.parseInt(maxResultsRaw);

        draft.pagination.resultCount = maxResults;
        draft.pagination.pageCount = _.ceil(
          maxResults / draft.pagination.limit
        );

        draft.loadingList = false;
        draft.list = _.sortBy(billingAdvances, 'name');
        break;
      case GET_ADVANCE_LIST_FAILURE:
        draft.loadingList = false;
        break;
      case GET_PATIENT_ADVANCE_LIST_IN_PROGRESS:
        draft.patientAdvances.loadingList = true;
        break;
      case GET_PATIENT_ADVANCE_LIST_SUCCESS:
        const patientAdvances = _.get(payload, 'response.data', []);

        draft.patientAdvances.loadingList = false;
        draft.patientAdvances.list = patientAdvances;
        break;
      case GET_PATIENT_ADVANCE_LIST_FAILURE:
        draft.patientAdvances.loadingList = false;
        break;
      case CLEAR_PATIENT_ADVANCE_LIST:
        draft.patientAdvances.list = [];
        break;
      case GET_ADVANCE_DETAIL_IN_PROGRESS:
        draft.loadingDetail = true;
        break;
      case GET_ADVANCE_DETAIL_SUCCESS:
      case UPDATE_ADVANCE_SUCCESS:
      case PATCH_ADVANCE_SUCCESS:
      case REMOVE_ADVANCE_SUCCESS:
        const advance = AdvanceModel.fromDto(
          _.get(payload, 'response.data', {})
        );

        draft.loadingDetail = false;
        draft.detail = advance;
        break;
      case GET_ADVANCE_DETAIL_FAILURE:
        draft.loadingDetail = false;
        break;
      case CLEAR_ADVANCE_DETAIL:
        draft.detail = null;
        break;
      case SET_ADVANCE_LIST_FILTER:
        setFilterToStoreDraft(draft, payload, initialState.pagination.page);

        break;
      case SET_ADVANCE_LIST_FILTERS:
        const filters = _.getNonEmpty(payload, 'filters', []);

        setFiltersToStoreDraft(draft, filters, initialState.pagination.page);

        break;
      case SET_ADVANCE_LIST_ORDER:
        const sortBy = _.getNonEmpty(payload, 'sortBy', null);
        const order = _.get(payload, 'order', ORDER_ASCENDING);

        draft.filter.sortBy = sortBy;
        draft.filter.order = order;
        break;
      case SET_ADVANCE_LIST_PAGINATION:
        const paginationName = _.getNonEmpty(payload, 'paginationName', null);
        const paginationValue = _.get(payload, 'paginationValue', '');

        if (!_.isEmpty(paginationName)) {
          draft.pagination[paginationName] = paginationValue;
        }
        break;
      case GET_ADVANCE_PAYMENTS_LIST_IN_PROGRESS:
        draft.payments.loadingPaymentsList = true;
        break;
      case GET_ADVANCE_PAYMENTS_LIST_SUCCESS:
        const advancePayments = _.get(payload, 'response.data', []);

        draft.payments.list = advancePayments;
        break;
      case GET_ADVANCE_PAYMENTS_LIST_FAILURE:
        draft.payments.loadingPaymentsList = false;
        break;
      case CLEAR_ADVANCE_PAYMENTS_LIST:
        draft.payments = {
          loadingPaymentsList: false,
          list: []
        };
        break;
      case CLEAR_ADVANCE_LIST_FILTER:
      case CLEAR_ADVANCE_LIST_FILTER_NO_POLL:
        draft.filter = initialState.filter;
        break;
      case SET_ADVANCE_LIST_INCLUDE_PARAM:
        draft.include = _.get(payload, 'includeValue');
        break;
      case LOGOUT:
        return initialState;
      default:
    }
  });

export default advanceReducer;
